// extracted by mini-css-extract-plugin
export default {"root":"VerticalScrollList-root","listItem":"VerticalScrollList-listItem"};